<template>
    <CompassModal
        v-model:visible="showModal"
        size="small"
        :title="
            $t.__('listing.batchComponents.ChangeGenerationModeComponent.change_generation_mode')
        "
        class="change-generation-mode-component"
        @closed="close"
    >
        <template #header>
            <div class="dialog__header">
                <div class="dialog__header--title"></div>
                <div class="dialog__header--close">
                    <CompassIconButton icon="close" @click="$emit('close')" />
                </div>
            </div>
        </template>
        <template #default>
            <div class="dialog__default">
                <p class="typographies-paragraph-medium-regular">
                    {{ $l10n.__('Deux modes sont disponibles :') }}
                </p>
                <ul style="list-style-type: disc" class="ml-2">
                    <li>
                        {{
                            $l10n.__(
                                'Mode "Automatique" : Envoie automatiquement un email avec la facture à votre destinataire.',
                            )
                        }}
                    </li>
                    <li>
                        {{
                            $l10n.__(
                                'Mode "Après validation" : Vous recevez une notification de création de facture et vous pourrez ensuite transmettre manuellement la facture à votre client.',
                            )
                        }}
                    </li>
                </ul>

                <div v-for="modeItem in modes" :key="modeItem.value" class="mb-2">
                    <el-radio v-model="mode" :value="modeItem.value">
                        {{ modeItem.label }}
                    </el-radio>
                </div>
            </div>
        </template>
        <template #footer>
            <div class="dialog__footer">
                <CompassButton
                    :label="$t.__('common.actions.cancel')"
                    type="secondary"
                    @click="close()"
                />
                <CompassButton
                    :label="$t.__('common.actions.confirm')"
                    type="primary"
                    class="ml-3"
                    @click="save"
                />
            </div>
        </template>
    </CompassModal>
</template>

<script>
import { ListingEvent } from 'js/types/events';
export default {
    props: {
        rows: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            showModal: true,
            loading: true,
            mode: '',
            modes: [],
        };
    },
    created() {
        this.initModes();
    },
    methods: {
        initModes() {
            this.$ajax.get(`/recurring/modes`, {}, (response) => {
                this.modes = response;
                this.initMode();
                this.loading = false;
            });
        },

        initMode() {
            this.mode = Object.keys(this.modes)[0];
        },

        save() {
            this.loading = true;
            this.$ajax.post(
                `/recurrings/mode/update/` + this.mode,
                {},
                { recIds: this.rows },
                () => {
                    Push.success(this.$l10n.__('Le mode a bien été mis à jour'));
                    this.close();
                    EventBus.emit(ListingEvent.REFRESH);
                },
                () => {
                    this.close();
                    Push.error(this.$l10n.__('Une erreur est survenue'));
                },
            );
        },
        close() {
            this.$emit('close');
        },
    },
};
</script>

<style lang="scss">
.change-generation-mode-component {
    .dialog {
        &__header {
            display: flex;
            justify-content: space-between;
            padding: 24px 32px;

            &--title {
                display: flex;
                flex-direction: column;
            }

            &--close {
                display: flex;
                justify-content: flex-end;
                align-items: flex-start;
            }
        }

        &__default {
            padding-bottom: 24px;
            p {
                margin: 0 0 var(--spacing-3);
            }
            ul {
                margin-top: var(--spacing-3);
                margin-bottom: var(--spacing-3);
            }
        }

        &__footer {
            display: flex;
            justify-content: flex-end;
            padding: 0 32px 24px 32px;
        }
    }
}
</style>
